<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
  <header class="row margin-bottom mb16 upload-container">
    <div class="col">
      <div class="upload-document">
        <span>
          <img src="./assets/img/images/icon-file-document.svg" alt="document file icon" />
        </span>
        <h1 class="title mb-2">
          {{ "Upload documents to claim" | translate }}
          <span class="txt-bold">
            {{ claimid }}
          </span>
          <span class="loss-cause">
            {{ claim?.lossCause }}
          </span>
        </h1>
        <p class="para">
          Upload up to 10 files. Maximum size 50MB per file (JPG, PDF, GIF & PNG)
        </p>
      </div>
      <div class="document-lists-block container-block mb-4">
        <ul class="list-group list-group-light">
          <li class="list-group-item" *ngFor="let file of fileList; let i=index">
            <span class="date-txt mr-2"> {{ file.date | date: "MM/dd/yyyy" }} </span>
            <span class="d-flex flex-common flex-1">
              <span class="photo-txt mr-2 flex-1">
                {{ file.photo }}
              </span>
              <span class="scene-txt mr-2"> {{ file.docType }} </span>
            </span>
            <span class="edit-delete mr-2">
              <span (click)="updateFiles('edit', file, $event, i)">
                <img src="./assets/img/images/icon-edit.svg" alt="edit icon" />                
              </span>
            </span>
            <span class="edit-delete">
              <span (click)="updateFiles('delete', file, $event, i)">
                <img src="./assets/img/images/icon-delete.svg" alt="delete icon" />               
                </span>
            </span>
          </li>
        </ul>
        <p class="para mb-4 mt-4" *ngIf="fileList.length ===10">
          You’ve reached the limit of files you can upload.
        </p>
      </div>
      <div class="add-document-block container-block" *ngIf="fileList.length < 10">
        <span>
          <img src="./assets/img/images/icon-image-gallery.svg" alt="image gallery icon" />
        </span>
        <h1 class="title">Add documents</h1>        
        <app-brwose-files (uploadFileEvent)="onFileUpload($event)"></app-brwose-files>
      </div>
      <div class="text-center mt-4 d-flex flex-column">
        <mapfre-button
          (click)="continue()"
          *ngIf="fileList.length"
          [ngClass]="{'custom_loader':loader}"          
          additionalClasses="basic primary small-btn h40 margin-bottom mb24 letter-space-17 w-100-mobile"
          [inputType]="'submit'"
          [disabledValue]="!loader" 
          [translateValue]="'Continue' | translate"
        >
          {{ "Continue" | translate }}
        </mapfre-button>
        <mapfre-button
          (click)="onClickCancel()"          
          additionalClasses="ghost secondary small-btn h32 no-padding letter-space-17 w-100-mobile"
          >{{ "CANCEL" | translate }}
        </mapfre-button>
      </div>
    </div>
  </header>
  <section>
    <app-uploading-files-modal
      *ngIf="showUploadModal"
      [uploadedFile]="uploadedFile"
      (closeModal)="closeModal()"
      (uploadFileEvent)="saveUploadedFile($event)"
      [invalidFileType] = "invalidFileType"
      [selectedFileData] = "selectedFileData"
    ></app-uploading-files-modal>
    <app-edit-file-modal
      *ngIf="showEditFile"
      [uploadedFile]="uploadedFile"
      (closeModal)="closeModal()"
      (uploadFileEvent)="saveUploadedFileOnEdit($event)"
      [invalidFileType] = "invalidFileType"
      [selectedFileData] = "selectedFileData"
    ></app-edit-file-modal>
    <app-remove-file-modal
      *ngIf="showDeleteFile"
      [uploadedFile]="uploadedFile"
      (closeModal)="closeModal()"
      (deleteDocument)="deleteUploadedDoc()"  
      [selectedFileData] ="selectedFileData"
    ></app-remove-file-modal>
    <app-update-confirm-file-modal
      [uploadedFile]="uploadedFile"
      (closeModal)="closeModal()"
    *ngIf="existConfirmModal">
    </app-update-confirm-file-modal>
  </section>
</ng-container>
